import styled from 'styled-components'
import { Persona } from '@fluentui/react/lib/PersonaCoin'

export const CustomPersona = styled(Persona).attrs({
  imageShouldFadeIn: false,
})``
